import { Navigate } from "react-router-dom";
import { PATHS } from "@/lib/router";
import DataEntryPage from "./pages/DataEntryPage";
import DataEntryOverviewPage from "./pages/DataEntryOverviewPage";
import KpiDashboardPage from "./pages/KpiDashboardPage";

export const dataEntryRoutes = [
  {
    path: PATHS.DATA_ENTRY_DASHBOARD,
    element: <KpiDashboardPage />,
    handle: { permission: { resource: "esg_data_entry", action: "view" } },
  },
  {
    path: PATHS.DATA_ENTRY_OVERVIEW,
    element: <DataEntryOverviewPage />,
    handle: { permission: { resource: "esg_data_entry", action: "view" } },
  },
  {
    // Legacy route — Consolidated is now a switch on the Overview page.
    path: PATHS.DATA_ENTRY_CONSOLIDATED,
    element: (
      <Navigate to={`${PATHS.DATA_ENTRY_OVERVIEW}?view=consolidated`} replace />
    ),
    handle: { permission: { resource: "esg_data_entry", action: "view" } },
  },
  {
    path: PATHS.DATA_ENTRY,
    element: <DataEntryPage />,
    handle: { permission: { resource: "esg_data_entry", action: "view" } },
  },
];
